module.exports = __webpack_public_path__ + "static/media/web-construction-mobile.ddedd4c0.svg";